import { render, staticRenderFns } from "./consultRecord.pug?vue&type=template&id=2e065dd4&lang=pug&"
import script from "./consultRecord.ts?vue&type=script&lang=ts&"
export * from "./consultRecord.ts?vue&type=script&lang=ts&"
import style0 from "./consultRecord.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports